export class StringHelper {
    public static truncateIfTooLong(value: string, maxLength:number, truncateChars = "...") {
        if (!value || value.length <= maxLength){return value;}
        const charsLength = truncateChars?.length || 0;
        return value.substring(0, maxLength-charsLength) + truncateChars;
    }
}